// Dependencies
require("webstrap/type");
require("grid");
require("section/generic");
require("section/img-text");
require("element/rich-text");



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/text-detail/index.js
 ** module id = 170
 ** module chunks = 0 1
 **/